import script from "./TripListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TripListComponent.vue?vue&type=script&setup=true&lang=js"

import "./TripListComponent.vue?vue&type=style&index=0&id=4c9aacb1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9aacb1"]])

export default __exports__